import React from 'react';
import {clearCaches} from "browserslist";

class CacheClearButton extends React.Component {
    clearCache = () => {
        localStorage.clear(); // Clear localStorage

        const linkElement = document.querySelector('link[rel="stylesheet"]');
        if (linkElement) {
            const href = linkElement.getAttribute('href');
            if (href) {
                const hrefWithUniqueQueryParam = href + '?cache=' + Date.now();
                linkElement.setAttribute('href', hrefWithUniqueQueryParam);
            }
        }
        window.location.reload(true);

    }

    render() {
        return (
            <div className={`col-md-4 col-xl-2 col-6 text-center cursor-pointer `} >

                <div className={`mb-2 card bg-success text-white`}  onClick={this.clearCache}>
                    <div className={ `card-header bg-success fix-height`} >
                        <span>پاک کردن حافظه نهان</span>

                    </div>

                </div>
            </div>

        );
    }
}

export default CacheClearButton;
